import(/* webpackChunkName: "forms" */ '../Styles/forms.scss');

await import(/* webpackChunkName: "parents" */ 'Feature/Common/code/Scripts/Common/parents');

window.am = window.am || {};

window.am.forms = new function () {
    var that = this;
    var infoIconActiveClass = 'active';
    const linkButtonDisabledClass = "link-button--inactive";

    that.init = function () {
        if (!hasForms()) {
            return;
        }

        initSubmitButton();
        initHighlightElementsOnFocus();
        setupFormsValidationHandling();
        initAccordionCheckboxes();
        initLabelInfoIcons();
        initLinkedFieldValidationSummary();
        window.addEventListener('resizeEnd', that.correctMarginTopForInfoboxes);
    };

    function initSubmitButton() {

        var forms = document.querySelectorAll('.am-form form.auto-disable-submitbutton');

        for (let i = 0; i < forms.length; i++) {
            let form = forms[i];

            form.addEventListener('submit', function () {
                return that.shouldSubmit(form);
            });
        }
    }

    that.shouldSubmit = function (form) {
        if (!that.hasSubmitButton(form)) {
            return true;
        }

        if (that.isSubmitButtonDisabled(form)) {
            return false;
        }

        if ($(form).valid()) {
            that.disableSubmitButton(form);
            return true;
        }

        return false;
    }

    that.hasSubmitButton = function(form)
    {
        let button = form.querySelector("[type='submit']");

        return button != null;
    }

    that.isSubmitButtonDisabled = function(form)
    {
        let button = form.querySelector("[type='submit']");

        if (button == null) {
            return false;
        }

        return button.classList.contains(linkButtonDisabledClass);
    }

    that.disableSubmitButton = function(form)
    {
        let button = form.querySelector("[type='submit']");

        if (button == null) {
            return;
        }

        if (button.classList.contains(linkButtonDisabledClass)) {
            return;
        }

        button.classList.add(linkButtonDisabledClass);
    }

    that.enableSubmitButton = function(form)
    {
        let button = form.querySelector("[type='submit']"); /* can be a input or button */

        if (button == null) {
            return;
        }

        if (!button.classList.contains(linkButtonDisabledClass)) {
            return;
        }

        button.classList.remove(linkButtonDisabledClass);
    }

    that.initShowHideIbanByParent = function (parentElement, name, changedCb) {

        if (parentElement == null) {
            return;
        }

        var radioButtons = parentElement.querySelectorAll('input[name="' + name + '"]');

        if (radioButtons == null || radioButtons.length == 0) {
            return;
        }

        var formField = radioButtons[0].parent('.form-field');

        if (formField == null) {
            return;
        }

        var targetElement = getElementByElementAttribute(
            formField, 'data-toggle-visibility-selector');

        if (targetElement == null) {
            return;
        }

        var hideClass = 'd-none';
        var noMarginBottomClass = 'mb-0';

        for (var i = 0; i < radioButtons.length; i++) {
            var button = radioButtons[i];

            button.addEventListener('change', function (e) {

                if (changedCb) {
                    changedCb(this, targetElement);
                }

                if (this.value === 'true') {
                    targetElement.classList.remove(hideClass);
                    formField.classList.remove(noMarginBottomClass);
                }
                else if (this.value === 'false') {
                    targetElement.classList.add(hideClass);
                    formField.classList.add(noMarginBottomClass);
                }
            });
        }
    }

    that.initShowHideElementByParent = function (parentElement, name, valueForHide, valueForShow, changedCb) {

        if (parentElement == null) {
            return;
        }

        var radioButtons = parentElement.querySelectorAll('input[name="' + name + '"]');

        if (radioButtons == null || radioButtons.length == 0) {
            return;
        }

        var formField = radioButtons[0].parent('.form-field');

        if (formField == null) {
            return;
        }

        var targetElement = getElementByElementAttribute(
            formField, 'data-toggle-visibility-selector');

        if (targetElement == null) {
            return;
        }

        var hideClass = 'd-none';
        var noMarginBottomClass = 'mb-0';

        for (var i = 0; i < radioButtons.length; i++) {
            var button = radioButtons[i];

            button.addEventListener('change', function (e) {

                if (changedCb) {
                    changedCb(this, targetElement);
                }

                if (this.value === valueForShow) {
                    targetElement.classList.remove(hideClass);
                    formField.classList.remove(noMarginBottomClass);
                }
                else if (this.value === valueForHide) {
                    targetElement.classList.add(hideClass);
                    formField.classList.add(noMarginBottomClass);
                }
            });
        }
    }

    that.initShowHideElementsByParent = function (parentElement, name, valueForHide, valueForShow, changedCb, cbInstance) {

        if (parentElement == null) {
            return;
        }

        var radioButtons = parentElement.querySelectorAll('input[name="' + name + '"]');

        if (radioButtons == null || radioButtons.length == 0) {
            return;
        }

        var formField = radioButtons[0].parent('.form-field');

        if (formField == null) {
            return;
        }

        var targetReferences = formField.getAttribute('data-toggle-visibility-selector');
        if (!targetReferences) {
            return;
        }
        targetReferences = targetReferences.split(',');        

        var hideClass = 'd-none';
        var noMarginBottomClass = 'mb-0';

        for (var i = 0; i < radioButtons.length; i++) {
            var button = radioButtons[i];

            button.addEventListener('change', function (e) {

                var those = e.target;
                targetReferences.forEach(function (reference) {
                    reference = reference.trim().slice(1);
                    var targetElement = document.getElementById(reference);

                    if (targetElement == null) {
                        return;
                    }

                    if (changedCb) {
                        changedCb.call(cbInstance, those, targetElement);
                    }

                    if (those.value === valueForShow) {
                        targetElement.classList.remove(hideClass);
                        formField.classList.remove(noMarginBottomClass);
                    }
                    else if (those.value === valueForHide) {
                        targetElement.classList.add(hideClass);
                        formField.classList.add(noMarginBottomClass);
                    }
                });


                
            });
        }
    }

    that.updateEventListenerForIbanFormField = function (ibanFieldWithVariousValidationMessage) {
        if (ibanFieldWithVariousValidationMessage && ibanFieldWithVariousValidationMessage.classList.contains('validation-service-error')) {
            var ibanFieldInputField = ibanFieldWithVariousValidationMessage.querySelector('input#Iban');
            if (ibanFieldInputField) {
                        ibanFieldInputField.addEventListener('input', function (element) {
                            //if there was a backend iban error, remove field error on filling in the iban field and replace the service error message with defaut one
                            ibanFieldWithVariousValidationMessage.classList.remove('has-errors');
                            ibanFieldWithVariousValidationMessage.classList.add('no-errors');
                            ibanFieldWithVariousValidationMessage.classList.remove('validation-service-error');
                            let fieldNotificationContainer = ibanFieldWithVariousValidationMessage.querySelector('.error.notification-container');
                            fieldNotificationContainer.querySelector('div.message').querySelector('p').innerHTML = ibanFieldInputField.getAttribute('data-alt-validation-message');

                            window.am.iban.initIbanFormat(ibanFieldInputField);
                        });
                    }
        }        
    }

    that.initializeForm = function ($form) {
        if (!$.validator) {
            console.warn('Missing "$.validator".Can\'t setup custom form validation handling.');

            return;
        }
        /* init validator */
        try {
            $.validator.unobtrusive.parse($form);    
        } catch (error) {
            console.warn("$.validator.unobtrusive.parse error: " + error);
            return;
        }
        

        /* get current validator configuration */
        var validator = $form.data("validator");

        var ignoreSettings = validator.settings.ignore;

        if (ignoreSettings != '') {
            ignoreSettings += ", ";
        }

        ignoreSettings += '.ignore-validation';

        validator.settings.ignore = ignoreSettings;
    }

    function getElementByElementAttribute(element, attr) {

        if (element == null || (attr == null || attr == '')) {
            return null;
        }

        var targetSelector = element.getAttribute(attr);

        if (!targetSelector || targetSelector == '') {
            return null;
        }

        var targetElement = document.querySelector(targetSelector);

        return targetElement;
    }

    function initLinkedFieldValidationSummary() {
        var errorContainer = document.querySelector('.notification-container');

        if (errorContainer == null) {
            return;
        }

        var errorLinkedFields = errorContainer.querySelectorAll('.validation-summary-errors li a');

        for (let i = 0; i < errorLinkedFields.length; i++) {
            let linkedField = errorLinkedFields[i];

            linkedField.addEventListener('click', function (e) {
                var url = this.getAttribute('href');

                if (!url) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }

                if (document.querySelector(url) != null) {
                    return;
                }

                var nameTarget = url.substring(1);

                var targetElement = document.querySelector('[name="' + nameTarget + '"]');

                if (targetElement == null) {
                    return;
                }

                e.preventDefault();
                e.stopPropagation();

                var y = targetElement.getBoundingClientRect().top + window.scrollY;

                window.scrollTo(0, y);
                targetElement.focus();
            });
        }
    };

    function initAccordionCheckboxes() {
        var cbWithAdditionalText = document.querySelectorAll(
            '.am-form .checkbox a[data-additional-text]');

        for (var j = 0; j < cbWithAdditionalText.length; j++) {
            var checkBox = cbWithAdditionalText[j];

            checkBox.addEventListener('click', function (e) {
                e.preventDefault();
                that.toggleAdditionalText(this);
            });
        }
    }

    that.toggleAdditionalText = function (element) {
        var formField = getFormField(element);

        if (!formField) {
            return;
        }

        var additionalText = formField.querySelector('.additional-text');

        if (additionalText != null && additionalText != undefined) {
            if (additionalText.classList.contains('show')) {
                additionalText.classList.remove('show');
                $(additionalText).stop().slideUp();
            }
            else {
                additionalText.classList.add('show');
                $(additionalText).stop().slideDown();
            }
        }
    }

    function initLabelInfoIcons() {
        var infoIcons = document.querySelectorAll(
            '.am-form .form-field .info-icon-button');

        for (var j = 0; j < infoIcons.length; j++) {
            var icon = infoIcons[j];

            icon.addEventListener('click', function (e) {
                e.preventDefault();
                that.toggleInfoBox(this);
            });
        }
    }

    that.toggleInfoBox = function (iconElement) {
        var formField = getFormField(iconElement);

        if (!formField) {
            return;
        }

        var infoBox = formField.querySelector('.notification-container.field-info');

        if (!infoBox) {
            return;
        }

        var wasActive = infoBox.classList.contains(infoIconActiveClass);
        var formfields = formField.parent().querySelectorAll('.form-field');

        iconElement.classList.toggle(infoIconActiveClass);
        infoBox.classList.toggle(infoIconActiveClass);

        if (wasActive) {

            for (var i = 0; i < formfields.length; i++) {
                if (formfields[i] != formField) {
                    formfields[i].style.marginTop = "";
                }
            }
        }
        else {
            var elementRect = iconElement.getBoundingClientRect();
            that.setMarginTopForInfobox(formField, formfields, elementRect);
            that.setMarginLeftForInfobox(iconElement, infoBox);
        }
    }

    that.setMarginTopForInfobox = function (infoBoxFormField, formfields, elementRect) {

        for (let i = 0; i < formfields.length; i++) {
            let formField = formfields[i];

            if (formField == infoBoxFormField) {
                continue;
            }

            formField.style.marginTop = "";
            var formFieldY = formField.getBoundingClientRect().top;

            if (infoBoxFormField.getBoundingClientRect().top != formFieldY) {
                continue;
            }

            formField.style.marginTop = parseFloat(elementRect.top - formFieldY) + "px";
        }
    }

    that.setMarginLeftForInfobox = function (activeInfoIcon, infoBox) {
        var message = infoBox.querySelector('.message');
        var messageX = message.getBoundingClientRect().left;
        /* Get Icon position instead of icon-button (wrapper) */
        var iconX = activeInfoIcon.querySelector('.info-icon').getBoundingClientRect().left;

        $(message).css({ "--left": parseInt(iconX) - parseInt(messageX) + 3 + "px" });
    }

    that.correctMarginTopForInfoboxes = function () {
        var fieldInfos = document.querySelectorAll(
            '.am-form .form-field .notification-container.field-info');

        for (let j = 0; j < fieldInfos.length; j++) {
            let fieldInfo = fieldInfos[j];
            let formField = getFormField(fieldInfo);

            if (!fieldInfo.classList.contains('active')) {
                continue;
            }

            let iconElement = formField.querySelector('.info-icon-button');

            if (!iconElement) {
                continue;
            }

            let row = formField.parent();
            let formfields = row.querySelectorAll('.form-field');

            that.setMarginTopForInfobox(
                formField, formfields, iconElement.getBoundingClientRect());
        }
    }

    /*
     * If you are here maybe you can check this issue if this is resolved now:
     * https://github.com/jquery-validation/jquery-validation/issues/2094
     * Aria-DescribedBy with the error id from the field is present even the field is valid.
    */
    function setupFormsValidationHandling() {
        if (!$.validator) {
            console.warn('Missing "$.validator".Can\'t setup custom form validation handling.');

            return;
        }

        // Resetting from for utilizing
        $('.am-form form').each(function() {
            $(this).removeData("unobtrusiveValidation").removeData("validator");
        });

        var settings = {
            highlight: function (element, errorClass, validClass) {
                var fieldElement = getFormField(element);

                if (fieldElement == null) {
                    element.classList.add('has-errors');
                    element.classList.remove('no-errors');
                    return;
                }

                var form = element.parent('.am-form');

                fieldElement.classList.add('has-errors');
                fieldElement.classList.remove('no-errors');

                var activeInfoIcon = fieldElement.querySelector('.info-icon.active');

                if (activeInfoIcon != null && activeInfoIcon != undefined) {
                    that.toggleInfoBox(activeInfoIcon);
                }

                window.setTimeout(function () {
                    if (window.am.sync) {
                        window.am.sync.adjustElements(form);
                    }
                }, 50);
            },
            unhighlight: function (element, errorClass, validClass) {
                var fieldElement = getFormField(element);

                if (fieldElement == null) {
                    element.classList.add('no-errors');
                    element.classList.remove('has-errors');
                    return;
                }

                var form = element.parent('.am-form');

                //fix for special case, if IBAN has two different validation- messages: client and cervice-failed validation 
                //(the last one should show an error even, if client validation: valid)
                if (!fieldElement.classList.contains('iban-various-validation')) {
                
                    fieldElement.classList.add('no-errors');
                    fieldElement.classList.remove('has-errors');
                }
                else if (!fieldElement.classList.contains('validation-service-error')){
                    fieldElement.classList.add('no-errors');
                    fieldElement.classList.remove('has-errors');
                }

                window.setTimeout(function () {
                    if (window.am.sync) {
                        window.am.sync.adjustElements(form);
                    }
                }, 50);
            }
        };

        $.validator.setDefaults(settings);

        $('.am-form form').each(function() {
            var $form = $(this);

            if (!that.shouldValidate($form)) {
                return true;
            }

            that.initializeForm($form);
        });
    }

    that.shouldValidate = function (element) {
        var $el = null;
        if (element instanceof jQuery) {
            $el = element;
        }
        else {
            $el = $(element);
        }

        if ($el == null) {
            return false;
        }

        var $form = $el.closest('form');

        if ($form == null) {
            return false;
        }

        /* No elements with validation are present so validator.settings will be null.
         * See https://stackoverflow.com/a/24593702/10236859
         * */
        return !($form.has('[data-val=true]').length == 0);
    }

    that.togglePasswordVisibility = function (element) {
        var inputElement = element.previousElementSibling;

        if (element.checked) {
            inputElement.type = "text";
        }
        else {
            inputElement.type = "password";
        }

        inputElement.focus();
    }

    var selectOnFocusEvent = function (element, removeClass) {
        var formField = getFormField(element);

        if (formField == null) {
            return;
        }

        if (removeClass && removeClass === true) {
            formField.classList.remove('form-field--active');
        }
        else {
            formField.classList.add('form-field--active');
        }

        var activeInfoButton = formField.querySelector('.info-icon-button.active');
        var activeInfoBox = formField.querySelector('.notification-container.field-info.active');

        if (activeInfoButton && activeInfoBox) {
            that.setMarginLeftForInfobox(activeInfoButton, activeInfoBox);
        }
    };

    /**
     * Can be used to validate invisible fields and removes the error class if the field is visible.
     * (Jquery validate does not remove error class on *invisible* elements if they are valid) :(
     * 
     * @param {any} element to validate.
     */
    function validateField(element) {

        if ($(element).valid()) {
            var form = element.parent('form');
            var validator = $(form).data("validator");
            var settings = validator.settings;

            settings.unhighlight.call(validator, element, settings.errorClass, settings.validClass);
        }
    }

    function getFormField(element) {
        var formField = element.parent('.field');

        if (!formField) {
            formField = element.parent('.form-field');
        }

        return formField;
    }

    function initHighlightElementsOnFocus() {
        var formElements = document.querySelectorAll(
            '.am-form select,' +
            '.am-form input[type="text"]:not(:disabled):not([readonly]),' +
            '.am-form input[type="password"],' +
            '.am-form input[type="email"],' +
            '.am-form input[type="date"],' +
            '.am-form input[type="tel"],' +
            '.am-form input[type="number"]');

        for (var i = 0; i < formElements.length; i++) {
            var formElement = formElements[i];

            formElement.addEventListener('blur', function (e) { selectOnFocusEvent(this, true); });
            formElement.addEventListener('focus', function () { selectOnFocusEvent(this); });
        }
    }

    function hasForms() {
        return document.querySelector('.am-form') != null;
    }
};

window.am.forms.init();